import { ValuableType } from '@/modules/asset/enums/ValuableType';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class ContactHardAssetDetail extends BaseEntityModel {
  id?: number;
  contactId?: number;
  ownedPrimaryResidence?: boolean;
  rentedPrimaryResidence?: boolean;
  ownedSecondaryResidence?: boolean;
  ownedCommercialRealEstate?: boolean;
  ownedOrRentedVehicles?: boolean;
  ownedValuables?: boolean;
  valuableTypes: ValuableType[];
  ownedFirearms?: boolean;

  constructor(model: Partial<ContactHardAssetDetail> = {}) {
    super(model);

    this.id = model.id;
    this.contactId = model.contactId;
    this.ownedPrimaryResidence = model.ownedPrimaryResidence;
    this.rentedPrimaryResidence = model.rentedPrimaryResidence;
    this.ownedSecondaryResidence = model.ownedSecondaryResidence;
    this.ownedCommercialRealEstate = model.ownedCommercialRealEstate;
    this.ownedOrRentedVehicles = model.ownedOrRentedVehicles;
    this.ownedValuables = model.ownedValuables;
    this.valuableTypes = model.valuableTypes ?? [];
    this.ownedFirearms = model.ownedFirearms;
  }
}
